import React from "react";
import loading from "../assets/logo.svg";

const Loading = () => (
  <div className="spinner">
    <img  id="logo-spinner" src={loading} alt="Loading" />
  </div>
);

export default Loading;
